export default __webpack_public_path__ + "static/media/HPE-APOLLO-FRONT.10f96813.png";